<template>
  <div>
    <el-table :data="list" border size="mini">
      <el-table-column prop="name" align="center" :label="$t('feedback_index.name')"></el-table-column>
      <el-table-column prop="tel" align="center" :label="$t('feedback_index.tel')"></el-table-column>
      <el-table-column prop="content" align="center" :label="$t('feedback_index.content')"></el-table-column>
      <el-table-column prop="remarks" align="center" :label="$t('feedback_index.remarks')"></el-table-column>
      <el-table-column prop="is_re" align="center" :label="$t('feedback_index.status')" :formatter="is_re_f"></el-table-column>
      <el-table-column prop="create_time" align="center" :label="$t('feedback_index.create_time')" :formatter="create_time_f"></el-table-column>
      <el-table-column align="center" :label="$t('index.operation')" width="300">
      	<template slot-scope="scope">
					<el-button size="mini" type="primary" v-if="hasBtn('reply')" @click="reply(scope.row)">{{$t('virtual.reply')}}</el-button>
					<el-button size="mini" type="danger" v-if="hasBtn('del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
					<el-button size="mini" type="primary" v-if="hasBtn('reply')" @click="remarks_ff(scope.row)">{{$t('feedback_index.remarks')}}</el-button>
				</template>
      </el-table-column>
    </el-table>
    <div class="page-pagination">
      <el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
    </div>
	<el-dialog :title="$t('virtual.reply')" width="800px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
		<el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm">
			<el-row :gutter="20">
				<el-col :span="24">
					<el-form-item :label="$t('feedback_index.name')">
						<div class="el-form-item__content">
							<div data-v-71d45262="" class="w100 el-input el-input--mini"><div class="el-input__inner">{{editForm.name}}</div></div>
						</div>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item :label="$t('feedback_index.content')">
						<div class="el-form-item__content">
							<div data-v-71d45262="" class="w100 el-input el-input--mini"><div class="el-textarea__inner">{{editForm.content}}</div></div>
						</div>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item :label="$t('feedback_index.reply_content')">
						<el-input v-model="editForm.re_content" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
			<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
		</div>
	</el-dialog>
	<el-dialog :title="$t('feedback_index.remarks')" width="800px" :close-on-click-modal="false" :visible="editFormVisible1" @close="editFormVisible1 = false">
		<el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm1">
			<el-row :gutter="20">
				<el-col :span="24">
					<el-form-item :label="$t('feedback_index.remarks')" prop="remarks">
						<el-input v-model="editForm.remarks" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="mini" @click.native="editFormVisible1 = false">{{$t('index.cancel')}}</el-button>
			<el-button size="mini" type="primary" @click.native="editSubmit1('editForm1')">{{$t('index.submit')}}</el-button>
		</div>
	</el-dialog>
  </div>
</template>
<script>
export default {
	inject:['home_init'],
	computed: {
		editFormRules() {
			return {
				remarks: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('feedback_index.remarks'),
					trigger: 'blur'
				}],
			}
		}
	},
	data() {
		return {
			list: [],
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
			editFormVisible:false,
			editFormVisible1:false,
			editForm:{
				name:'',
				content:'',
				re_content:'',
				id:'',
				remarks:'',
			},
		}
	},
	// 初始事件
	mounted: function () {
		this.init();
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "contactUsList";
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		create_time_f(w, s, d){
			return this.getTime_us(d,'mmddyyyy');
		},
		reply(data){
			this.editForm=data;
			this.editFormVisible=true;
		},
		editSubmit(){
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						content: this_.editForm.re_content,
						id: this_.editForm.id,
					}
					var url = "contactSendEmailAction";
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('feedback_index.reply_success'));
						this_.editFormVisible = false;
						this_.init();
						this_.home_init();
					});
				} else {
					return false;
				}
			})
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "deleteContactUs";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		is_re_f(w, s, d){
			return d?this.$t('feedback_index.replied'):this.$t('feedback_index.no_reply');
		},
		remarks_ff(data){
			this.editForm.id=data.id;
			this.editForm.remarks=data.remarks;
			this.editFormVisible1=true;
		},
		editSubmit1(editForm){
			var this_ = this;
			this_.$refs[editForm].validate((valid) => {
				if (valid) {
					var datas = {
						table: 'contact_us',
						field: 'remarks',
						value: this_.editForm.remarks,
						pk_id: this_.editForm.id,
					}
					var url = "changeField";
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.add_success'));
						this_.editFormVisible1 = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	/* margin-bottom: 22px; */
}
.page-pagination {
	padding: 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/feedback/index.vue